// Shared with Prints.js (assigning a print's category) and Posts.js
// (assigning a purchasable post's photos to a Gallery category) so the two
// admin screens never drift out of sync with each other.
export const GALLERY_CATEGORIES = [
  '2027 Calendar',
  'Beachscapes',
  'Best Selling',
  'Digital Art',
  'Dodging Shadows',
  'Flora & Fauna',
  'Landmarks',
  'Northeaster',
  'OBX Sunrise',
  'Pelicans',
  'Ripples',
  'Waves',
];
